import usePromotionsMgrBase from 'commerceAPI/hooks/usePromotionsMgr';

export const usePromotionsMgr = () => {
	const useBasePromotions = usePromotionsMgrBase();

	return useBasePromotions;
};